
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="main-header">
      <div className="logo">
        <NavLink to="/">NP</NavLink>
      </div>
      <nav className={`main-nav ${isOpen ? 'open' : ''}`}>
        <ul>
          <li><NavLink to="/" end onClick={toggleMenu}>Home</NavLink></li>
          <li><NavLink to="/about" onClick={toggleMenu}>About</NavLink></li>
          <li><NavLink to="/portfolio" onClick={toggleMenu}>Portfolio</NavLink></li>
          <li><a href="https://nachopereira.com/dj" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>DJ Sets</a></li>
          <li><NavLink to="/contact" onClick={toggleMenu}>Contact</NavLink></li>
        </ul>
      </nav>
      <button className="hamburger" onClick={toggleMenu}>
        <span className="hamburger-box">
          <span className="hamburger-inner"></span>
        </span>
      </button>
    </header>
  );
}

export default Header;
